import {
    AITaskResponse,
    AITaskRequest,
    AITaskRequestContext
} from '../types/public-types';
import { IHttpClient } from '@honeybook/core';
import { AITaskListResponse } from '../types/server-types';
import { packageInfo } from '../package-info';

export class AITaskAdapter {
    protected readonly httpClient: IHttpClient;

    constructor(httpClient: IHttpClient) {
        this.httpClient = httpClient;
    }

    _executeTask(request: AITaskRequest): Promise<AITaskResponse> {
        // Add package version information to the task context
        const requestWithVersion = {
            ...request,
            context: {
                ...(request.context || {}),
                versions: {
                    ...(request.context?.versions || {}),
                    [packageInfo.name]: packageInfo.version
                }
            } as AITaskRequestContext
        };

        return this.httpClient.request<AITaskResponse>({
            method: 'post',
            url: '/api/v2/ai_tasks',
            data: requestWithVersion
        });
    }

    _fetchTasks(taskIds?: string[]): Promise<AITaskListResponse> {
        const data = taskIds ? { task_ids: taskIds } : {};
        return this.httpClient.request<AITaskListResponse>({
            method: 'post',
            url: '/api/v2/ai_tasks_filtered',
            data
        });
    }

    _getTask(taskId: string): Promise<AITaskResponse> {
        return this.httpClient.request<AITaskResponse>({
            method: 'get',
            url: `/api/v2/ai_tasks/${taskId}`
        });
    }
}
